export default __webpack_public_path__ + "assets/images/ilustracao-usuario-sucesso7648051cc4ffb23b984f0049942f6a55.png";